import { pathOr } from '@/helpers/functional'
import JwtService from '@/api/jwt.service'
import SessionStorageService from '@/api/session-storage.service'
import { SessionService, DriverService } from '@/api/api.service'
import {
  SESSION_LOGIN,
  SESSION_LOGOUT,
  SESSION_CHECK_AUTH,
  SESSION_GET_LOGIN,
  SESSION_UPDATE_PLAN
} from '@/store/actions.type'
import {
  SESSION_PURGE_AUTH,
  SESSION_SET_LOGIN,
  SESSION_SET_PAYMENT,
  SESSION_ADD_CARD,
  SESSION_SET_NEW_PLAN_DATA,
  SESSION_ADD_PAYMENT
} from '@/store/mutations.type'

const initialState = {
  user: null,
  cards: [],
  payment: [],
  isAuthenticated: false
}

export const state = Object.assign({}, initialState)

const actions = {
  async [SESSION_LOGIN]({ commit }, credentials) {
    const { data } = await SessionService.login(credentials)
    commit(SESSION_SET_LOGIN, data)
  },
  async [SESSION_GET_LOGIN](context) {
    const login = SessionStorageService.getLogin()
    if (!login) {
      context.commit(SESSION_PURGE_AUTH)
    } else {
      context.commit(SESSION_SET_LOGIN, login)
    }
  },

  async [SESSION_CHECK_AUTH]({ commit, getters, dispatch }) {
    if (!getters.getIsAuthenticated && SessionStorageService.getLogin()) {
      await dispatch(SESSION_GET_LOGIN)
    } else if (!getters.getIsAuthenticated) {
      commit(SESSION_PURGE_AUTH)
    }
  },
  async [SESSION_LOGOUT]({ commit }) {
    commit(SESSION_PURGE_AUTH)
  },
  async [SESSION_UPDATE_PLAN]({ commit }, planId) {
    const { data } = await DriverService.updatePlan({
      plan_id: planId
    })
    commit(SESSION_SET_NEW_PLAN_DATA, data)
  }
}

const mutations = {
  [SESSION_SET_LOGIN](state, login) {
    const cards = pathOr(null, ['data', 'cards'], login)
    const user = pathOr(null, ['data', 'driver'], login)
    const token = pathOr(null, ['data', 'token'], login)
    const payment = pathOr(null, ['data', 'payment'], login)

    JwtService.saveToken(token)
    SessionStorageService.saveLogin(login)

    state.isAuthenticated = true
    state.user = user
    state.payment = payment
    state.cards = cards
  },
  [SESSION_SET_PAYMENT](state, payment) {
    const login = SessionStorageService.getLogin()
    const newLogin = { ...login }
    newLogin.data.payment = payment

    SessionStorageService.destroyLogin()
    state.payment = payment

    SessionStorageService.saveLogin(newLogin)
  },
  [SESSION_PURGE_AUTH](state) {
    JwtService.destroyTokens()
    SessionStorageService.destroyLogin()
    state.isAuthenticated = false
    state.user = null
    state.cards = null
    state.payment = null
  },
  [SESSION_ADD_CARD](state, card) {
    state.cards.push(card)
  },
  [SESSION_SET_NEW_PLAN_DATA](state, data) {
    const user = pathOr(null, ['data', 'driver'], data)
    const payment = pathOr(null, ['data', 'payment'], data)

    const login = SessionStorageService.getLogin()
    const newLogin = { ...login }
    newLogin.data.driver = user
    newLogin.data.payment = payment

    SessionStorageService.destroyLogin()
    state.user = user
    state.payment = payment

    SessionStorageService.saveLogin(newLogin)
  },
  [SESSION_ADD_PAYMENT](state, { payment, payment_id }) {
    const login = SessionStorageService.getLogin()
    const newLogin = { ...login }
    const storedPayment = pathOr(null, ['data', 'payment'], newLogin)
    const newPayment = {
      ...storedPayment,
      id: payment_id
    }
    const existPayment = newPayment.payments.find(
      (p) => p.payment_gateway_id === payment.payment_gateway_id
    )
    if (!existPayment) newPayment.payments.push(payment)

    SessionStorageService.destroyLogin()
    state.payment = newPayment
    newLogin.data.payment = newPayment
    SessionStorageService.saveLogin(newLogin)
  }
}

const getters = {
  getIsAuthenticated: (state) => {
    return state.isAuthenticated
  },
  getSessionUser: (state) => {
    return state.user
  },
  getSessionCards: (state) => {
    const cards = state.cards
    const formatted = cards.map((elem) => {
      return {
        display_name: `${elem.brand} ••••${elem.last_4_digits}`,
        ...elem
      }
    })
    return formatted
  },
  getSessionPayment: (state) => {
    return state.payment || null
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
